var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableComponentDownloadDocIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70825 11.0703C3.13487 11.0703 3.48071 11.4162 3.48071 11.8428V14.9326C3.48071 15.1375 3.5621 15.334 3.70696 15.4788C3.85183 15.6237 4.0483 15.7051 4.25317 15.7051H15.0676C15.2725 15.7051 15.469 15.6237 15.6138 15.4788C15.7587 15.334 15.8401 15.1375 15.8401 14.9326V11.8428C15.8401 11.4162 16.1859 11.0703 16.6125 11.0703C17.0392 11.0703 17.385 11.4162 17.385 11.8428V14.9326C17.385 15.5472 17.1409 16.1367 16.7063 16.5713C16.2717 17.0058 15.6822 17.25 15.0676 17.25H4.25317C3.63857 17.25 3.04913 17.0058 2.61454 16.5713C2.17994 16.1367 1.93579 15.5472 1.93579 14.9326V11.8428C1.93579 11.4162 2.28163 11.0703 2.70825 11.0703Z",
    fill: "#23235F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25188 7.43719C5.55355 7.13552 6.04264 7.13552 6.34431 7.43719L9.6604 10.7533L12.9765 7.43719C13.2782 7.13552 13.7673 7.13552 14.0689 7.43719C14.3706 7.73885 14.3706 8.22795 14.0689 8.52961L10.2066 12.3919C9.90495 12.6936 9.41585 12.6936 9.11419 12.3919L5.25188 8.52961C4.95022 8.22795 4.95022 7.73885 5.25188 7.43719Z",
    fill: "#23235F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6604 1.80469C10.087 1.80469 10.4329 2.15053 10.4329 2.57715V11.8467C10.4329 12.2733 10.087 12.6191 9.6604 12.6191C9.23378 12.6191 8.88794 12.2733 8.88794 11.8467V2.57715C8.88794 2.15053 9.23378 1.80469 9.6604 1.80469Z",
    fill: "#23235F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableComponentDownloadDocIcon);
export default __webpack_public_path__ + "static/media/TableComponentDownloadDocIcon.a788eecf38dff2399bedb6891ed72bbc.svg";
export { ForwardRef as ReactComponent };